import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Loader, Table} from 'semantic-ui-react';
import {convertDateToSpecificFormat} from '../../../common/util/date';
import ChassisInfoModal from './modal/chassisInfo';

class VehiclesEfficiencyTable extends Component {
  renderVehiclesList() {
    const {vehiclesList} = this.props;
    if (!vehiclesList.length) {
      return (
        <Table.Row >
          <Table.Cell textAlign='center' colSpan={27}>
            No hay vehículos que cumplan con los filtros ingresados
          </Table.Cell>
        </Table.Row>
      );
    }

    return vehiclesList.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.modelName}</Table.Cell>
          <Table.Cell textAlign='center'>{`${element.sfx}/${element.katashiki}`}</Table.Cell>
          <Table.Cell textAlign='center'>{element.chassis}</Table.Cell>
          <Table.Cell textAlign='center'>{element.reservedName}</Table.Cell>
          <Table.Cell textAlign='center'>{convertDateToSpecificFormat(element.arrivalDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{convertDateToSpecificFormat(element.liquidationDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{convertDateToSpecificFormat(element.availableDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{convertDateToSpecificFormat(element.priorityDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{convertDateToSpecificFormat(element.changeDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{convertDateToSpecificFormat(element.wholesaleDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{convertDateToSpecificFormat(element.dealersaleDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{element.difWholesaleAndArrival}</Table.Cell>
          <Table.Cell textAlign='center'>{element.difAvailableAndLiquidation}</Table.Cell>
          <Table.Cell textAlign='center'>{element.difPriorityAndAvailable}</Table.Cell>
          <Table.Cell textAlign='center'>{element.difWholesaleAndLiquidation}</Table.Cell>
          <Table.Cell textAlign='center'>{element.difWholesaleAndPriority}</Table.Cell>
          <Table.Cell textAlign='center'>
            <ChassisInfoModal item={element} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrVehicles() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderVehiclesList();
  }

  render() {
    return (
      <Card fluid raised>
        <div className='table-container'>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center' className='model-column'>Modelo</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='katashiki-column'>SFX/Katashiki</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Chasis</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='reserved-column'>Reservado</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-column'>F. Llegada</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-column'>F. Liquidación</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-column'>F. Disponible</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-column'>F. Priorización</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-column'>F. Cambio Estado</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-column'>F. Wholesale</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-column'>F. Venta Dealer</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-differences-column'>
              Wholesale - Llegada
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-differences-column'>
              Disponible - Liquidación
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-differences-column'>
              Priorización - Disponible
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-differences-column'>
              Wholesale - Liquidación
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center' className='date-differences-column'>
              Wholesale - Priorización
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
    
            <Table.Body>
              {this.renderLoaderOrVehicles()}
            </Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehicleEfficiency.loading,
    'vehiclesList': state.vehicleEfficiency.list,
  };
};

export default connect(mapStateToProps, {})(VehiclesEfficiencyTable);
